// membership/privacy/privacyNotice.js
// 個人資料蒐集、處理及利用告知事項（入會與移入共用）。
//
// 放在中性位置而非某一版的版本目錄下，因為兩邊取用的規則不同：
//   入會：只有 106 顯示，由 versions/v106/notice.js 的 getPrivacyNotice() 提供
//   移入：只有原會籍為 106 的會員才顯示（移入 = 重新簽署，但舊版會員當初未被告知，故不追溯），
//         由 MembershipTransferInSurvey 依 resolvePrivacyItemIndex(originalContractVersion) 判斷
//
// ⚠️ 改這裡的文字會同時改變所有既有文件「查看」時顯示的內容（PDF 是 blob 存檔，不受影響）。
import icon_privacy from "@icoach/assets/img/icon_doc_privacy.png";

const privacyNotice = {
	icon: icon_privacy,
	title: "個人資料蒐集、處理及利用告知事項",
	preface: "感謝您加入我們的會員！為了提供您完善的服務與會員權益，我們將依法蒐集、處理及利用您的個人資料：",
	// 個資法第 8 條的告知要素，label 即要素名稱
	terms: [
		{
			label: "蒐集目的",
			text: "用於會員身分驗證、提供會員專屬優惠與服務通知、訂單與客戶服務處理，以及優化我們的服務品質（屬客戶管理與服務、行銷業務等範疇）。",
		},
		{
			label: "蒐集項目",
			text: "姓名、聯絡電話、電子郵件、通訊地址等您於註冊表單所提供之資訊。",
		},
		{
			label: "利用期間與地區",
			text: "於本服務營運期間及依法令規定之保存期限內，於我們營運之地區利用。",
		},
	],
	// 權益說明，非個資法告知要素，故不給 label
	rights: "您得自由選擇是否提供個資，但若拒絕提供，可能無法順利完成會員註冊或享有相關會員權益。若您欲查詢、閱覽、補充、更正或請求刪除您的個人資料，隨時可聯繫我們。",
};

/**
 * 個資告知在 106 版 contractSurvey.items 陣列的固定位置。
 *
 * 一旦有文件用 106 簽署並存進資料庫，該筆資料的第 7 格就永遠代表個資告知，任何情況下都不得再更動這個值。
 * 這條規則由 MembershipCreateContentSurvey.test.jsx 的測試守住。
 *
 * 個資告知在畫面上排最前面，但資料放最後一格，是因為 items 是純索引的 bool 陣列，
 * PDF（Membership_202610.cshtml）依 Items[0..6] 硬索引讀取。若插在陣列前段，
 * 既有須知全部往後位移一格，之後產生的文件在 PDF 上每個勾選區塊都會印錯。
 *
 * 未來若有新版本且須知條數不同，由該版本自行宣告自己的值，不要沿用這個（101-105 沒有這個匯出，代表該版本沒有個資卡片）。
 */
export const PRIVACY_ITEM_INDEX = 7;

export default privacyNotice;
